const cmLegacy = require('./reducers/v1/cmLegacy');
const cmLegalDocuments = require('./reducers/cmLegalDocuments');
const cm = require('./reducers/cmWalletBuy');

module.exports = {
    cmLegalDocuments,
    cmLegacy,
    cm
};
